var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.041,
    height: 29.041,
    viewBox: "0 0 29.041 29.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "md-log-in",
    transform: "translate(-4.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47015",
    "data-name": "Pfad 47015",
    d: "M19.26,4.5A14.52,14.52,0,0,0,5.7,13.827l-.258.726h3.19L8.76,14.2a11.5,11.5,0,1,1,0,9.627l-.133-.349H5.438l.251.726A14.524,14.524,0,1,0,19.26,4.5Z",
    transform: "translate(-0.239)",
    fill: "#44554c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47016",
    "data-name": "Pfad 47016",
    d: "M4.5,23.2H17.743L14.7,26.316,16.787,28.4l6.7-6.7-6.7-6.7-2.164,2.087,3.121,3.121H4.5Z",
    transform: "translate(0 -2.681)",
    fill: "#44554c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow-circle.0f73f746a06e67988961b473b4e9b32b.svg";
export { ForwardRef as ReactComponent };